module.exports = __webpack_public_path__ + "img/org-review-good.e5196e5d.svg";